import React from "react";
import {Nullable} from "../../../../../@typings/typings";
import {QuestionRenderLatex} from "../../atoms/QuestionRenderLatex";

interface QuestionRenderHintProps {
    hint: Nullable<string>;
}

export default function QuestionRenderHint({ hint }: QuestionRenderHintProps) {
    return <QuestionRenderLatex renderString={hint} title={"Подсказка"} />
}